module.exports = __webpack_public_path__ + "static/media/tank.29853278.svg";